export default __webpack_public_path__ + "static/media/Animals13.f9bab049.jpg";